import { Typography } from '../primitives/index.js'
import { capitalize } from '@tunasong/models'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import { useDeviceUISettings } from '../hooks/device-ui-settings.js'
import TagList from '../tags/tag-list.js'
import ContentViews from './content-views.js'
import { Divider } from './divider.js'
import { useContentViews } from '@tunasong/plugin-lib'

export interface ContentContainerSettingsProps {
  className?: string
  entity: Persisted<Entity>

  EntityControls?: FC<{ entity?: Persisted<Entity>; onActive?: (active: boolean) => void }>
}

export const ContentContainerSettings: FC<ContentContainerSettingsProps> = props => {
  const { entity, EntityControls, ...restProps } = props

  const contentViews = useContentViews(entity)

  // Filter by tags
  const { tagsFilter, setTagsFilter } = useDeviceUISettings()

  return (
    // This is the scroll container for the contentEl
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          // hack to avoid opacity flickering
          transform: 'rotate(0)',
          transition: 'opacity 195ms cubic-bezier(0.4, 0, 0.6, 1)',
        }}
        {...restProps}
      >
        {contentViews.length > 1 ? (
          <>
            <Typography variant="subtitle1" style={{ marginTop: 8, marginBottom: 8 }}>
              Content view
            </Typography>
            <ContentViews entity={entity} />
          </>
        ) : null}

        <Typography variant="subtitle1" style={{ marginTop: 8, marginBottom: 8 }}>
          Show by tags
        </Typography>
        <TagList tabIndex={-1} placeholder="Show by tag(s)" tags={tagsFilter} onChange={setTagsFilter} size="small" />

        {EntityControls ? (
          <>
            <Divider>{capitalize(entity.type)} settings</Divider>
            <EntityControls entity={entity} />
          </>
        ) : null}
      </div>
    </>
  )
}

export default ContentContainerSettings
